import React, { useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { datadogRum } from '@datadog/browser-rum';
import { Typography } from '@mui/material';

import { useAppDispatch } from '../../state/hooks';
import { resetUserDetails, updateUserDetails, updateUserLoginStatus } from '../../state/features/userSlice';
import { TTCUser } from '../../interfaces/services/tid';
import { getTTCBaseUrl } from '../../utils/environmentUtils';
import { ApiStatus } from '../../utils/enums';
import AuthService from '../../services/authService';
import ApiService from '../../services/apiService';
import OverlaySpinner from '../../components/Loaders/OverlaySpinner';

const Authorize = (): React.JSX.Element => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        (async (): Promise<void> => {
            const user = await AuthService.loginRedirect();
            if (user !== null && user.access_token) {
                const ttcBaseUrl = getTTCBaseUrl();

                try {
                    const { data: userDetails } = await ApiService.get({
                        url: `${ttcBaseUrl}/iam/v2/users/${user.profile.sub}`,
                    }) as AxiosResponse<TTCUser>;

                    datadogRum.setUser({
                        id: user.profile.sub,
                        sub: user.profile.sub,
                        name: userDetails.name,
                        email: user.profile.email,
                        accountId: userDetails.accountId,
                        accountName: userDetails.accountName,
                        ttcUserId: userDetails.ttcUserObjectId,
                    });

                    dispatch(updateUserDetails(userDetails));
                } catch (error) {
                    console.error('Error fetching user permissions', error);
                    dispatch(resetUserDetails());
                }

                dispatch(updateUserLoginStatus(ApiStatus.Success));
            } else {
                dispatch(updateUserLoginStatus(ApiStatus.Failure));
            }
        })();
    }, [dispatch]);

    return (
        <OverlaySpinner noBackground>
            <Typography variant='subtitle2'>
                Loading user info...
            </Typography>
        </OverlaySpinner>
    );
};

export default Authorize;
